import * as z from "zod";
import { TFunction } from "i18next";

export const createCatalogueFormSchema = (t: TFunction) =>
  z.object({
    name: z.string().min(1, t("validation.required", "Ad alanı zorunludur")),
    surname: z
      .string()
      .min(1, t("validation.required", "Soyad alanı zorunludur")),
    email: z
      .string()
      .min(1, t("validation.required", "E-posta zorunludur"))
      .email(t("validation.emailInvalid", "Geçerli bir e-posta girin")),
    phone: z
      .string()
      .min(
        10,
        t("validation.phoneInvalid", "Geçerli bir telefon numarası girin")
      ),
    company: z.string().optional(),
    occupation: z.string().optional(),
    nickname: z.string().optional(),
    formLoadTimestamp: z.number().optional(),
  });

export type CatalogueFormData = z.infer<
  ReturnType<typeof createCatalogueFormSchema>
>;
